<template>
    <vx-popover hover arrow placement="top">
        <vx-badge size="xs" color="rose" data-test="sso-deprovisioned-badge">
            <font-awesome-icon :icon="faUserSlash" class="-mx-0.5" /> Deprovisioned
        </vx-badge>
        <template v-slot:content>
            <div class="max-w-xs">
                Unassigned or deactivated at the identity provider; can log in again once assigned
            </div>
        </template>
    </vx-popover>
</template>

<script lang="ts" setup>
import { faUserSlash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBadge, VxPopover } from '@voxie/frontend-components';
</script>
